import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';

export interface ApprovalRequiredNoticeProps {
  className?: string;
  variant?: string;
  classNames?: {
    container?: string;
    icon?: string;
    text?: string;
  };
  children?: React.ReactNode;
  /** Optional explicit message; falls back to children, then default copy. */
  message?: string;
}

const DEFAULT_MESSAGE =
  'This order will need approval by your manager before it can be shipped.';

const ApprovalRequiredNotice: React.FC<ApprovalRequiredNoticeProps> = ({
  className,
  variant = 'default',
  classNames: classNameOverrides,
  children,
  message,
}) => {
  const containerClassName = useClassNames([
    'approval-notice',
    `approval-notice--${variant}`,
    classNameOverrides?.container,
    className,
  ]);

  const iconClassName = useClassNames([
    'approval-notice__icon',
    `approval-notice__icon--${variant}`,
    classNameOverrides?.icon,
  ]);

  const textClassName = useClassNames(['approval-notice__text', classNameOverrides?.text]);

  return (
    <div role="alert" className={containerClassName} data-testid="atom-approval-required-notice">
      <ExclamationTriangleIcon aria-hidden="true" className={iconClassName} />
      <span className={textClassName}>{children ?? message ?? DEFAULT_MESSAGE}</span>
    </div>
  );
};

export default ApprovalRequiredNotice;
